import React from 'react';
import ReactDOM from 'react-dom/client';
import { initDataDogRUM } from '@picsart/datadog-rum';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import Providers from './providers';
import dataDogConfig from './constants/dd_params';

if (import.meta.env.VITE_APP_DD_INIT === 'true') {
  initDataDogRUM(dataDogConfig);
}
/* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Providers>
        <App />
      </Providers>
    </BrowserRouter>
  </React.StrictMode>,
);
